import React from 'react'
import { Fade, makeStyles, Paper, Popper, Tooltip } from "@material-ui/core"
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  actionButton: {
    padding: '0.5rem 1rem',
    backgroundColor: 'white',
    transition: 'background-color 0.3s ease',
    '&:hover': {
      backgroundColor: 'lightgray',
      cursor: 'pointer',
    },
  },
  popperMenu: {
    borderRadius: '0.5rem',
    marginLeft: '-10%',
    marginRight: '10%',
    boxShadow: '1px 2px 6px 1px gray',
    '& :first-child': {
      borderTopLeftRadius: '0.5rem',
      borderTopRightRadius: '0.5rem',
    },
    '& :last-child': {
      borderBottomLeftRadius: '0.5rem',
      borderBottomRightRadius: '0.5rem',
    },
  },
  disabled: {
    cursor: 'not-allowed',
    backgroundColor: '#cccccc',
    color: '#666666',
    '&:hover': {
      cursor: 'not-allowed',
      filter: 'brightness(90%)',
    },
  },
}))

const Action = props => {
  const { action, index, classes, onClose } = props

  const handleClick = () => {
    if (!action.disabled) {
      onClose()
      action.onClick()
    }
  }

  const className = clsx(
    classes.actionButton,
    action.className,
    action.disabled && 'disabled',
    action.disabled && classes.disabled
  )

  const title = action.tooltip ? action.tooltip : ''

  return (
    <Tooltip title={title} key={'action' + index}>
      <div className={className} onClick={handleClick}>
        {action.text}
      </div>
    </Tooltip>
  )
}

const SettingsPopper = (props) => {
  const { open, actions, parentRef, onClose } = props
  const classes = useStyles()
  return (
    <Popper
      anchorEl={parentRef.current}
      placement={'bottom-end'}
      open={open}
      transition
    >
      {({ TransitionProps }) => (
        <Fade {...TransitionProps} timeout={200}>
          <Paper className={classes.popperMenu}>
            {actions.map((action, i) => (
              <Action action={action} index={i} classes={classes} onClose={onClose}/>
            ))}
          </Paper>
        </Fade>
      )}
    </Popper>
  )
}

export default SettingsPopper
